// extracted by mini-css-extract-plugin
export var grayCircle = "_dx-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_dx-1";
export var selectedCircle = "_dx-2";
export var shippingOptionImage = "_dx-3";
export var shippingOptionWidgetPreview = "_dx-4";